import { render, staticRenderFns } from "./BusInspectionTaskList.vue?vue&type=template&id=2aa868cb&scoped=true&"
import script from "./BusInspectionTaskList.vue?vue&type=script&lang=js&"
export * from "./BusInspectionTaskList.vue?vue&type=script&lang=js&"
import style0 from "./BusInspectionTaskList.vue?vue&type=style&index=0&id=2aa868cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa868cb",
  null
  
)

export default component.exports